import { motion } from "framer-motion";
import { Monitor, Armchair, Wind, Headphones, Coffee, Sparkles, Heart, Dog, Baby, Wrench } from "lucide-react";

const wedges = [
  { icon: Monitor, label: "Electronics" },
  { icon: Armchair, label: "Furniture" },
  { icon: Wind, label: "Appliances" },
  { icon: Headphones, label: "Audio" },
  { icon: Coffee, label: "Kitchen" },
  { icon: Sparkles, label: "Beauty" },
  { icon: Heart, label: "Health" },
  { icon: Dog, label: "Pet" },
  { icon: Baby, label: "Baby" },
  { icon: Wrench, label: "Tools" },
];

export default function WedgeBadges() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4, delay: 0.45 }}
      className="mt-2 mb-2 w-full max-w-md mx-auto overflow-hidden"
    >
      <div className="flex items-center justify-center">
        <span className="text-[10px] text-muted-foreground/60 font-body mr-1.5 shrink-0">Covers queries in</span>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-1.5 mt-1.5 px-1">
        {wedges.map((w) => {
          const Icon = w.icon;
          return (
            <span
              key={w.label}
              className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-border/30 bg-muted/15 text-[10px] text-muted-foreground font-body whitespace-nowrap"
            >
              <Icon className="w-2.5 h-2.5" />
              {w.label}
            </span>
          );
        })}
      </div>
    </motion.div>
  );
}
